import classNames from 'classnames';
import { useMotionValueEvent, useScroll } from 'framer-motion';
import { useRef, useState } from 'react';
import { useMediaQueryDeviceStateValue } from '@/shared/atoms/media-query-device';
import { ImageShape, VideoShape } from '@/shared/lib/types';
import Video from '../Video/Video';

export type VideoRevealProps = {
    desktopVideo: VideoShape;
    mobileVideo?: VideoShape;
    poster?: ImageShape | null;
    posterMobile?: ImageShape | null;
};

type Props = React.HTMLAttributes<HTMLElement> & {
    videoRevealProps: VideoRevealProps;
};

const VideoReveal = ({ videoRevealProps }: Props) => {
    const videoSectionRef = useRef<HTMLElement | null>(null);
    const [isVideoHidden, setIsVideoHidden] = useState(false);
    const { scrollYProgress } = useScroll({ target: videoSectionRef, offset: ['start start', 'end start'] });
    const device = useMediaQueryDeviceStateValue();
    const isDesktop = device === 'desktop';
    const mobileVideo = videoRevealProps.mobileVideo || videoRevealProps.desktopVideo;
    const video = isDesktop ? videoRevealProps.desktopVideo : mobileVideo;

    useMotionValueEvent(scrollYProgress, 'change', (progress) => {
        setIsVideoHidden(progress > 0.1);
    });
    const poster = isDesktop ? videoRevealProps.poster : videoRevealProps.posterMobile || null;

    return (
        <section className="video-reveal__section js-header-theme-trigger" data-theme="light" ref={videoSectionRef}>
            <div className={classNames('showreel-video-wrapper', { 'hidden-video': isVideoHidden })}>
                <Video className="showreel-video" autoPlay muted playsInline loop sources={video} previewImg={poster} />
            </div>
        </section>
    );
};

export default VideoReveal;
